import { render } from "./LiveCasinoPage.vue?vue&type=template&id=a05389b4&scoped=true"
import script from "./LiveCasinoPage.vue?vue&type=script&lang=js"
export * from "./LiveCasinoPage.vue?vue&type=script&lang=js"

import "./LiveCasinoPage.vue?vue&type=style&index=0&id=a05389b4&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a05389b4"]])

export default __exports__